import React from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';

const FormButtonToolbar = (props) => {
  function getNextButton(){
    return(
        <Button onClick={props.nextStep}>{props.applicationUpdated ? 'Save and Continue' : 'Next'}</Button>
    )
  }

  function getPreviousButton(){
    return <Button onClick={props.previousStep}>Previous</Button>
  }

  function getSubmitButton(){
    return <Button onClick={props.onSubmit} disabled={!props.canSubmit}>Submit</Button>
  }

  return(
  <ButtonToolbar className="button-toolbar">
    {props.step > 1 && getPreviousButton()}
    {props.step < props.maxStep && getNextButton()}
    {props.step === props.maxStep && getSubmitButton()}
  </ButtonToolbar>
  );
};

export default FormButtonToolbar;